/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import { useForm } from "react-hook-form";
import { IPackage } from "@/utilities/types/Package";
import { Button, Input } from "rizzui";
import { IoMdClose } from "react-icons/io";
import { DatePicker } from "@/components/ui/datepicker";
import { PiTrashDuotone } from "react-icons/pi";

interface IPackageFormProps {
  pkg: IPackage;
  userPkgExpiredAt: Date | null;
  onSubmit: (data: { expiredAt: Date | null }) => void;
  onClose: () => void;
}

export const PackageForm: React.FC<IPackageFormProps> = ({
  pkg,
  onSubmit,
  onClose,
  userPkgExpiredAt,
}) => {
  const {
    setValue,
    watch,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    defaultValues: {
      expiredAt: userPkgExpiredAt || (pkg.expiredAt ? new Date(pkg.expiredAt) : null),
    },
  });

  const onChangeExpiredDate = (date: Date) => {
    setValue("expiredAt", date);
  };

  const onClear = ()=>{
    setValue("expiredAt", null);
  };

  React.useEffect(() => {
    return () => reset();
  }, []);

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="space-y-4 p-6">
      <div className="flex items-center justify-end">
        <span className="cursor-pointer" onClick={onClose}>
          <IoMdClose size={24} />
        </span>
      </div>

      {/* Name */}
      <div>
        <label
          htmlFor="name"
          className="block text-sm font-medium text-gray-700"
        >
          Package Name
        </label>
        <Input
          readOnly
          disabled
          value={pkg.name}
          id="name"
          type="text"
          className="mt-1 block w-full rounded-md border-gray-300 shadow-sm  sm:text-sm disabled:bg-gray-100 disabled:cursor-not-allowed"
        />
      </div>

      {/* Description */}
      <div>
        <label
          htmlFor="description"
          className="block text-sm font-medium text-gray-700"
        >
          Description
        </label>
        <Input
          readOnly
          disabled
          value={pkg.description || ""}
          id="description"
          type="text"
          className="mt-1 block w-full rounded-md border-gray-300 shadow-sm  sm:text-sm disabled:bg-gray-100 disabled:cursor-not-allowed"
        />
      </div>

      {/* expired Date */}
      <div>
        <label
          htmlFor="expiredDate"
          className="block text-sm font-medium text-gray-700"
        >
          Expired Date
        </label>
        <DatePicker
          id="expiredDate"
          selected={watch("expiredAt")}
          onChange={(date: Date) => onChangeExpiredDate(date)}
          dateFormat="dd MMM, yyyy"
          placeholderText="Select expired Date"
          popperPlacement="bottom-end"
          inputProps={{
            variant: "text",
            inputClassName: "p-0 px-1 h-auto [&_input]:text-ellipsis",
            id: "expiredDate",
          }}
          className="w-fit rounded border [&_.rizzui-input-container]:px-3 [&_.rizzui-input-container]:py-1.5 "
        />
      </div>
      <div className="pt-4 flex flex-row justify-between items-center">
        <Button type="button" onClick={onClear}>
          <PiTrashDuotone size={20} className="mr-2" /> Clear
        </Button>
        <Button type="submit">Save</Button>
      </div>
    </form>
  );
};
